import { render } from "./App.vue?vue&type=template&id=552226cc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=552226cc&lang=css"

import exportComponent from "/Users/nceba/Documents/code/apps/twist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__